import { NgModule } from '@angular/core';
import { PanGestureDirective } from './directives/pan-gesture.directive';
import { HammerGestureAdapter } from './hammer-gesture.adapter';
import { GESTURE_ADAPTER } from './gesture.tokens';


@NgModule({
  declarations: [
    PanGestureDirective
  ],
  exports: [
    PanGestureDirective
  ],
  providers: [
    {
      provide: GESTURE_ADAPTER,
      useClass: HammerGestureAdapter
    }
  ]
})
export class GestureModule {}
